/** @format */
import { css } from 'styled-components';

/**
 * The lift every card on the bento grid takes under the pointer, shared so
 * all of them answer the same way. A card using this must set its own
 * resting shadow, since what deepens depends on what it started from.
 */
export const cardHoverLift = css`
    transition-property: box-shadow, transform;
    transition-duration: var(--animations-default-duration);
    transition-timing-function: var(--animations-default-timing-function);

    @media (hover: hover) {
        &:hover {
            box-shadow: var(--effects-shadow-lg);
            transform: translateY(-0.3rem);
        }
    }

    @media (prefers-reduced-motion: reduce) {
        &:hover {
            transform: none;
        }
    }
`;
